import Entity from '../../schema/Entity';
import Reservation from '../../schema/Reservation';
import assignPerson from './assignPerson';

/**
 * parse data for Reservation Entity
 */
export default function setReservationEntityData(
    entityItem: Entity,
    entityBlob: any,
    isReservationIdRequired?: boolean
): Reservation {
    if (entityItem && entityBlob) {
        // get the correct ID
        let entityReservationId: string;
        if (entityBlob.reservationId) {
            entityReservationId = entityBlob.reservationId;
        } else if (entityBlob.reservationNumber) {
            entityReservationId = entityBlob.reservationNumber;
        } else if (!isReservationIdRequired) {
            // don't create entity when no Reservation Id / Number and isReservationIdRequired is false
            return null;
        }

        // assign reservation data
        let underName = entityBlob.underName;
        let reservationEntity: Reservation = {
            ...entityItem,
            ...{
                reservationId: entityReservationId,
                reservationStatus: entityBlob.reservationStatus,
                modifyReservationUrl: entityBlob.modifyReservationUrl,
                underName: assignPerson({}, underName),
            },
        };
        let reservedTicket = entityBlob.reservedTicket;
        if (reservedTicket) {
            let seat = reservedTicket.ticketSeat;
            reservationEntity = {
                ...reservationEntity,
                ...{
                    reservedTicket: {
                        ticketNumber: reservedTicket.ticketNumber,
                        seat: {
                            row: seat ? seat.seatRow : null,
                            seatNumber: seat ? seat.seatNumber : null,
                            section: seat ? seat.seatSection : null,
                        },
                    },
                },
            };
        }
        return reservationEntity as Reservation;
    }
    return null;
}
